module.exports = __webpack_public_path__ + "static/media/mc_pulse_grey.6c4f4133.svg";